import React, { Component } from 'react';
import { Divider, Grid, Segment, Button, Form, Message } from 'semantic-ui-react'
import { budgetURL } from "../../shared/urls/clientapi";
import { callService, GET, PUT } from "../../shared/serviceInvoker";
import { returnErrorMessage } from "../../shared/utils";
import BudgetHeader from "../BudgetHeaderMonthly/index";
import BudgetItem from "../BudgetItemMonthly/index";
import ReactGA from 'react-ga';
import { trackEvent } from '../../shared/tracking';
import { checkFalselyRequired, checkFalselyValue } from "../../shared/helpers/validators";
import MyMessage from "../Message/index";

export default class Budget extends Component {
  constructor(props) {
    super(props);

    let url = budgetURL.replace('{contact_id}', sessionStorage.contact_id);
    this.budgetURL = url + 'no'; //querystring

    this.state = {
      afterPull: props.afterPull || null,

      success: false,
      error: false,
      errorMessage: '',
      showLoader: true,
      budget_totals: [],
      budget_totals_projected: [],
      budget_totals_previous: [],
      budget_totals_average: [],
      take_home_pay: 0,
      other_income: 0,
      alimony: 0,
      child_support_gain: 0,
      social_security: 0,
      retirement_income: 0,
      rent: 0,
      utilities: 0,
      transportation: 0,
      insurance_premiums: 0,
      food: 0,
      telephone: 0,
      medical_bills: 0,
      back_taxes: 0,
      student_loans: 0,
      child_support_loss: 0,
      child_care: 0,
      other_expenses: 0,
      rent_2: 0,
      auto_other: 0,
      tv: 0,
      charity: 0,
      clothing: 0,
      education: 0,
      entertainment: 0,
      health: 0,
      home_insurance: 0,
      household_items: 0,
      life_insurance: 0,
      laundry: 0,
      medical_care: 0,

      projected_take_home_pay: 0,
      projected_other_income: 0,
      projected_alimony: 0,
      projected_child_support_gain: 0,
      projected_social_security: 0,
      projected_retirement_income: 0,
      projected_rent: 0,
      projected_utilities: 0,
      projected_transportation: 0,
      projected_insurance_premiums: 0,
      projected_food: 0,
      projected_telephone: 0,
      projected_medical_bills: 0,
      projected_back_taxes: 0,
      projected_student_loans: 0,
      projected_child_support_loss: 0,
      projected_child_care: 0,
      projected_other_expenses: 0,
      projected_rent_2: 0,
      projected_auto_other: 0,
      projected_tv: 0,
      projected_charity: 0,
      projected_clothing: 0,
      projected_education: 0,
      projected_entertainment: 0,
      projected_health: 0,
      projected_home_insurance: 0,
      projected_household_items: 0,
      projected_life_insurance: 0,
      projected_laundry: 0,
      projected_medical_care: 0,
      take_home_pay_valid: false,
      other_income_valid: false,
      alimony_valid: false,
      child_support_gain_valid: false,
      social_security_valid: false,
      retirement_income_valid: false,
      rent_valid: false,
      utilities_valid: false,
      transportation_valid: false,
      insurance_premiums_valid: false,
      food_valid: false,
      telephone_valid: false,
      medical_bills_valid: false,
      back_taxes_valid: false,
      student_loans_valid: false,
      child_support_loss_valid: false,
      child_care_valid: false,
      other_expenses_valid: false,
      rent_2_valid: false,
      auto_other_valid: false,
      tv_valid: false,
      charity_valid: false,
      clothing_valid: false,
      education_valid: false,
      entertainment_valid: false,
      health_valid: false,
      home_insurance_valid: false,
      household_items_valid: false,
      life_insurance_valid: false,
      laundry_valid: false,
      medical_care_valid: false,
      formValid: false,
      projected_readonly: false,
      actual_readonly: false,

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleUserInput = this.handleUserInput.bind(this);
  }

  handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const number = (target.validity.valid) ? value : this.state[name];
    this.setState({
      [name]: number,
    });
  };

  handleUserInput = (e) => {
    const target = e.target;
    const name = e.target.name;
    const value = e.target.value;
    const number = (target.validity.valid) ? value : this.state[name];
    this.setState({ [name]: number },
      () => { this.validateFields() });
  };

  validateFields = () => {

    this.setState({
      take_home_pay_valid: checkFalselyRequired(this.state.projected_take_home_pay),
      other_income_valid: checkFalselyRequired(this.state.projected_other_income),
      alimony_valid: checkFalselyRequired(this.state.projected_alimony),
      child_support_gain_valid: checkFalselyRequired(this.state.projected_child_support_gain),
      social_security_valid: checkFalselyRequired(this.state.projected_social_security),
      retirement_income_valid: checkFalselyRequired(this.state.projected_retirement_income),
      rent_valid: checkFalselyRequired(this.state.projected_rent),
      utilities_valid: checkFalselyRequired(this.state.projected_utilities),
      transportation_valid: checkFalselyRequired(this.state.projected_transportation),
      insurance_premiums_valid: checkFalselyRequired(this.state.projected_insurance_premiums),
      food_valid: checkFalselyRequired(this.state.projected_food),
      telephone_valid: checkFalselyRequired(this.state.projected_telephone),
      medical_bills_valid: checkFalselyRequired(this.state.projected_medical_bills),
      back_taxes_valid: checkFalselyRequired(this.state.projected_back_taxes),
      student_loans_valid: checkFalselyRequired(this.state.projected_student_loans),
      child_support_loss_valid: checkFalselyRequired(this.state.projected_child_support_loss),
      child_care_valid: checkFalselyRequired(this.state.projected_child_care),
      other_expenses_valid: checkFalselyRequired(this.state.projected_other_expenses),
      rent_2_valid: checkFalselyRequired(this.state.projected_rent_2),
      auto_other_valid: checkFalselyRequired(this.state.projected_auto_other),
      tv_valid: checkFalselyRequired(this.state.projected_tv),
      charity_valid: checkFalselyRequired(this.state.projected_charity),
      clothing_valid: checkFalselyRequired(this.state.projected_clothing),
      education_valid: checkFalselyRequired(this.state.projected_education),
      entertainment_valid: checkFalselyRequired(this.state.projected_entertainment),
      health_valid: checkFalselyRequired(this.state.projected_health),
      home_insurance_valid: checkFalselyRequired(this.state.projected_home_insurance),
      household_items_valid: checkFalselyRequired(this.state.projected_household_items),
      life_insurance_valid: checkFalselyRequired(this.state.projected_life_insurance),
      laundry_valid: checkFalselyRequired(this.state.projected_laundry),
      medical_care_valid: checkFalselyRequired(this.state.projected_medical_care),
    }, this.validateForm);
  };

  validateForm = () => {
    if (sessionStorage.getItem('isImpersonating') === 'true') {
      this.setState({ formValid: false });
    } else if (this.state.projected_readonly) {
      this.setState({ formValid: true });
    } else {
      this.setState({
        formValid:
          checkFalselyValue(this.state.take_home_pay_valid) &&
          checkFalselyValue(this.state.other_income_valid) &&
          checkFalselyValue(this.state.alimony_valid) &&
          checkFalselyValue(this.state.child_support_gain_valid) &&
          checkFalselyValue(this.state.social_security_valid) &&
          checkFalselyValue(this.state.retirement_income_valid) &&
          checkFalselyValue(this.state.rent_valid) &&
          checkFalselyValue(this.state.utilities_valid) &&
          checkFalselyValue(this.state.transportation_valid) &&
          checkFalselyValue(this.state.insurance_premiums_valid) &&
          checkFalselyValue(this.state.food_valid) &&
          checkFalselyValue(this.state.telephone_valid) &&
          checkFalselyValue(this.state.medical_bills_valid) &&
          checkFalselyValue(this.state.back_taxes_valid) &&
          checkFalselyValue(this.state.student_loans_valid) &&
          checkFalselyValue(this.state.child_support_loss_valid) &&
          checkFalselyValue(this.state.child_care_valid) &&
          checkFalselyValue(this.state.other_expenses_valid) &&
          checkFalselyValue(this.state.rent_2_valid) &&
          checkFalselyValue(this.state.auto_other_valid) &&
          checkFalselyValue(this.state.tv_valid) &&
          checkFalselyValue(this.state.charity_valid) &&
          checkFalselyValue(this.state.clothing_valid) &&
          checkFalselyValue(this.state.education_valid) &&
          checkFalselyValue(this.state.entertainment_valid) &&
          checkFalselyValue(this.state.health_valid) &&
          checkFalselyValue(this.state.home_insurance_valid) &&
          checkFalselyValue(this.state.household_items_valid) &&
          checkFalselyValue(this.state.life_insurance_valid) &&
          checkFalselyValue(this.state.laundry_valid) &&
          checkFalselyValue(this.state.medical_care_valid)
      });
    }
  };

  errorClass = (error) => {
    if (!this.state.projected_readonly) {
      return (error.length === 0 ? 'input-red' : '');
    } else {
      return '';
    }
  };

  componentDidMount() {
    let selectedBudget = this.props.selected_budget_type.split(' ');
    let selectedMonth = selectedBudget[0].replace('\'', '');
    let selectedYear = selectedBudget[1].replace('\'', '');
    let url = this.budgetURL + '&month=' + selectedMonth + '&year=' + selectedYear;

    const months = [
      'January', 'February', 'March', 'April', 'May', 'June', 'July',
      'August', 'September', 'October', 'November', 'December'
    ];

    function monthNameToNum(monthname) {
        const month = ('0' + (months.indexOf(monthname))).slice(-2);
        return month ? month : 0;
    }
    
    let date = new Date();
    let current_month = ('0' + (date.getMonth())).slice(-2)
    let current_year = date.getFullYear();
    let current_year_month = String(current_year) + String(current_month);
    let selected_year_month = selectedYear + monthNameToNum(selectedMonth);
    let projected_readonly = false;
    let actual_readonly = false;

    if (current_year_month > selected_year_month) {
        projected_readonly = true;
    }
    if (current_year_month < selected_year_month) {
        actual_readonly = true;
    }

    callService(
      GET,
      url,
      null,
      response => {
        let budget_totals = response.data.data.totals;
        let budget_totals_projected = response.data.data.projected.totals;
        let budget_totals_previous = response.data.data.total_previous_month;
        let budget_totals_average = response.data.data.total_average;
        let budget_incomes = response.data.data.incomes;
        let budget_expenses = response.data.data.expenses;
        let projected = response.data.data.projected;

        this.setState({
          showLoader: false,
          budget_totals: budget_totals,
          budget_totals_projected: budget_totals_projected,
          budget_totals_previous: budget_totals_previous,
          budget_totals_average: budget_totals_average,
          take_home_pay: checkFalselyValue(budget_incomes.take_home_pay),
          other_income: checkFalselyValue(budget_incomes.other_income),
          alimony: checkFalselyValue(budget_incomes.alimony),
          child_support_gain: checkFalselyValue(budget_incomes.child_support_gain),
          social_security: checkFalselyValue(budget_incomes.social_security),
          retirement_income: checkFalselyValue(budget_incomes.retirement_income),
          rent: checkFalselyValue(budget_expenses.rent),
          utilities: checkFalselyValue(budget_expenses.utilities),
          transportation: checkFalselyValue(budget_expenses.transportation),
          insurance_premiums: checkFalselyValue(budget_expenses.insurance_premiums),
          food: checkFalselyValue(budget_expenses.food),
          telephone: checkFalselyValue(budget_expenses.telephone),
          medical_bills: checkFalselyValue(budget_expenses.medical_bills),
          back_taxes: checkFalselyValue(budget_expenses.back_taxes),
          student_loans: checkFalselyValue(budget_expenses.student_loans),
          child_support_loss: checkFalselyValue(budget_expenses.child_support_loss),
          child_care: checkFalselyValue(budget_expenses.child_care),
          other_expenses: checkFalselyValue(budget_expenses.other_expenses),
          rent_2: checkFalselyValue(budget_expenses.rent_2),
          auto_other: checkFalselyValue(budget_expenses.auto_other),
          tv: checkFalselyValue(budget_expenses.tv),
          charity: checkFalselyValue(budget_expenses.charity),
          clothing: checkFalselyValue(budget_expenses.clothing),
          education: checkFalselyValue(budget_expenses.education),
          entertainment: checkFalselyValue(budget_expenses.entertainment),
          health: checkFalselyValue(budget_expenses.health),
          home_insurance: checkFalselyValue(budget_expenses.home_insurance),
          household_items: checkFalselyValue(budget_expenses.household_items),
          life_insurance: checkFalselyValue(budget_expenses.life_insurance),
          laundry: checkFalselyValue(budget_expenses.laundry),
          medical_care: checkFalselyValue(budget_expenses.medical_care),

          projected_take_home_pay: checkFalselyValue(projected.incomes.take_home_pay),
          projected_other_income: checkFalselyValue(projected.incomes.other_income),
          projected_alimony: checkFalselyValue(projected.incomes.alimony),
          projected_child_support_gain: checkFalselyValue(projected.incomes.child_support_gain),
          projected_social_security: checkFalselyValue(projected.incomes.social_security),
          projected_retirement_income: checkFalselyValue(projected.incomes.retirement_income),
          projected_rent: checkFalselyValue(projected.expenses.rent),
          projected_utilities: checkFalselyValue(projected.expenses.utilities),
          projected_transportation: checkFalselyValue(projected.expenses.transportation),
          projected_insurance_premiums: checkFalselyValue(projected.expenses.insurance_premiums),
          projected_food: checkFalselyValue(projected.expenses.food),
          projected_telephone: checkFalselyValue(projected.expenses.telephone),
          projected_medical_bills: checkFalselyValue(projected.expenses.medical_bills),
          projected_back_taxes: checkFalselyValue(projected.expenses.back_taxes),
          projected_student_loans: checkFalselyValue(projected.expenses.student_loans),
          projected_child_support_loss: checkFalselyValue(projected.expenses.child_support_loss),
          projected_child_care: checkFalselyValue(projected.expenses.child_care),
          projected_other_expenses: checkFalselyValue(projected.expenses.other_expenses),
          projected_rent_2: checkFalselyValue(projected.expenses.rent_2),
          projected_auto_other: checkFalselyValue(projected.expenses.auto_other),
          projected_tv: checkFalselyValue(projected.expenses.tv),
          projected_charity: checkFalselyValue(projected.expenses.charity),
          projected_clothing: checkFalselyValue(projected.expenses.clothing),
          projected_education: checkFalselyValue(projected.expenses.education),
          projected_entertainment: checkFalselyValue(projected.expenses.entertainment),
          projected_health: checkFalselyValue(projected.expenses.health),
          projected_home_insurance: checkFalselyValue(projected.expenses.home_insurance),
          projected_household_items: checkFalselyValue(projected.expenses.household_items),
          projected_life_insurance: checkFalselyValue(projected.expenses.life_insurance),
          projected_laundry: checkFalselyValue(projected.expenses.laundry),
          projected_medical_care: checkFalselyValue(projected.expenses.medical_care),

          projected_readonly: projected_readonly,
          actual_readonly: actual_readonly,

        });
        this.validateFields();
      },
      error => {
        this.setState({
          showLoader: false,
          error: true
        });
      }
    );
  }

  handleSubmit = (event) => {

    event.preventDefault();

    const { take_home_pay, other_income, alimony, child_support_gain, social_security, retirement_income, checking_account,
      rent, utilities, transportation, insurance_premiums, food, telephone, medical_bills, back_taxes, student_loans,
      child_support_loss, child_care, other_expenses, rent_2, auto_other, tv, charity, clothing, education, entertainment,
      health, home_insurance, household_items, life_insurance, laundry, medical_care, projected_take_home_pay,
      projected_other_income, projected_alimony, projected_child_support_gain, projected_social_security,
      projected_retirement_income, projected_checking_account, projected_rent, projected_utilities, projected_transportation,
      projected_insurance_premiums, projected_food, projected_telephone, projected_medical_bills, projected_back_taxes,
      projected_student_loans, projected_child_support_loss, projected_child_care, projected_other_expenses,
      projected_rent_2, projected_auto_other, projected_tv, projected_charity, projected_clothing, projected_education,
      projected_entertainment, projected_health, projected_home_insurance, projected_household_items, projected_life_insurance,
      projected_laundry, projected_medical_care } = this.state;

    let selectedBudget = this.props.selected_budget_type.split(' ');
    let selectedMonth = selectedBudget[0].replace('\'', '');
    let selectedYear = selectedBudget[1].replace('\'', '');

    let is_crm = false;
    if (selectedBudget === 'crm') {
      is_crm = true;
    }

    let bodyFormData = new FormData();
    bodyFormData.append('is_crm', is_crm);
    bodyFormData.append('budget_month', selectedMonth);
    bodyFormData.append('budget_year', selectedYear);

    bodyFormData.append('take_home_pay', take_home_pay || 0);
    bodyFormData.append('other_income', other_income || 0);
    bodyFormData.append('alimony', alimony || 0);
    bodyFormData.append('child_support_gain', child_support_gain || 0);
    bodyFormData.append('social_security', social_security || 0);
    bodyFormData.append('retirement_income', retirement_income || 0);
    bodyFormData.append('checking_account', checking_account || 0);
    bodyFormData.append('rent', rent || 0);
    bodyFormData.append('utilities', utilities || 0);
    bodyFormData.append('transportation', transportation || 0);
    bodyFormData.append('insurance_premiums', insurance_premiums || 0);
    bodyFormData.append('food', food || 0);
    bodyFormData.append('telephone', telephone || 0);
    bodyFormData.append('medical_bills', medical_bills || 0);
    bodyFormData.append('back_taxes', back_taxes || 0);
    bodyFormData.append('student_loans', student_loans || 0);
    bodyFormData.append('child_support_loss', child_support_loss || 0);
    bodyFormData.append('child_care', child_care || 0);
    bodyFormData.append('other_expenses', other_expenses || 0);
    bodyFormData.append('rent_2', rent_2 || 0);
    bodyFormData.append('auto_other', auto_other || 0);
    bodyFormData.append('tv', tv || 0);
    bodyFormData.append('charity', charity || 0);
    bodyFormData.append('clothing', clothing || 0);
    bodyFormData.append('education', education || 0);
    bodyFormData.append('entertainment', entertainment || 0);
    bodyFormData.append('health', health || 0);
    bodyFormData.append('home_insurance', home_insurance || 0);
    bodyFormData.append('household_items', household_items || 0);
    bodyFormData.append('life_insurance', life_insurance || 0);
    bodyFormData.append('laundry', laundry || 0);
    bodyFormData.append('medical_care', medical_care || 0);

    bodyFormData.append('projected_take_home_pay', projected_take_home_pay || 0);
    bodyFormData.append('projected_other_income', projected_other_income || 0);
    bodyFormData.append('projected_alimony', projected_alimony || 0);
    bodyFormData.append('projected_child_support_gain', projected_child_support_gain || 0);
    bodyFormData.append('projected_social_security', projected_social_security || 0);
    bodyFormData.append('projected_retirement_income', projected_retirement_income || 0);
    bodyFormData.append('projected_checking_account', projected_checking_account || 0);
    bodyFormData.append('projected_rent', projected_rent || 0);
    bodyFormData.append('projected_utilities', projected_utilities || 0);
    bodyFormData.append('projected_transportation', projected_transportation || 0);
    bodyFormData.append('projected_insurance_premiums', projected_insurance_premiums || 0);
    bodyFormData.append('projected_food', projected_food || 0);
    bodyFormData.append('projected_telephone', projected_telephone || 0);
    bodyFormData.append('projected_medical_bills', projected_medical_bills || 0);
    bodyFormData.append('projected_back_taxes', projected_back_taxes || 0);
    bodyFormData.append('projected_student_loans', projected_student_loans || 0);
    bodyFormData.append('projected_child_support_loss', projected_child_support_loss || 0);
    bodyFormData.append('projected_child_care', projected_child_care || 0);
    bodyFormData.append('projected_other_expenses', projected_other_expenses || 0);
    bodyFormData.append('projected_rent_2', projected_rent_2 || 0);
    bodyFormData.append('projected_auto_other', projected_auto_other || 0);
    bodyFormData.append('projected_tv', projected_tv || 0);
    bodyFormData.append('projected_charity', projected_charity || 0);
    bodyFormData.append('projected_clothing', projected_clothing || 0);
    bodyFormData.append('projected_education', projected_education || 0);
    bodyFormData.append('projected_entertainment', projected_entertainment || 0);
    bodyFormData.append('projected_health', projected_health || 0);
    bodyFormData.append('projected_home_insurance', projected_home_insurance || 0);
    bodyFormData.append('projected_household_items', projected_household_items || 0);
    bodyFormData.append('projected_life_insurance', projected_life_insurance || 0);
    bodyFormData.append('projected_laundry', projected_laundry || 0);
    bodyFormData.append('projected_medical_care', projected_medical_care || 0);

    let url = this.budgetURL + '&month=' + selectedMonth + '&year=' + selectedYear;

    callService(
      PUT,
      url,
      bodyFormData,
      response => {
        this.setState({ success: true, error: false });

        ReactGA.event({
          category: 'Budget',
          action: 'Budget Info Updated - ' + this.props.selected_budget_type,
        });

        trackEvent('Budget', 'Budget Info Updated - ' + this.props.selected_budget_type);
        this.componentDidMount();
      },
      error => {
        let msg = returnErrorMessage(error, "DefaultSaveError");
        this.setState({ success: false, error: true, errorMessage: msg });
      }
    );
  };

  render() {
    const {selected, budget_totals_projected, budget_totals_previous, budget_totals_average, formValid, showLoader, budget_totals, } = this.state;
    const projectedCashFlow = budget_totals_projected.cash_flow || null;
    return (
      <div>
        <Divider hidden />
        <Grid stackable>
          <Grid.Column width={2} className='grid-padding' />
          <Grid.Column width={12} className='grid-padding'>
            {
              selected !== 'crm' && projectedCashFlow && projectedCashFlow >= 50 ?
                <MyMessage
                  textAlign='center' style={{color: 'green'}}
                  message="Fantastic! You've done a great job of managing your expenses! Consider contributing some of your
                       extra money to your monthly deposit to get out of debt that much sooner. To increase your deposit
                       this month, contact us using the Support link above."
                />
                :
                null
            }
            {
              selected !== 'crm' && projectedCashFlow && projectedCashFlow <= -50 ?
                <MyMessage
                  textAlign='center' style={{color: 'red'}}
                  message="Oops! It looks like your expenses are a little more than you might be able to handle this month.
                       Consider seeing if you can cut back on what might be more optional expenses, such as Entertainment,
                       or purchases you might be able to delay, such as Clothing."
                />
                :
                null
            }
          </Grid.Column>
          <Grid.Column width={2} className='grid-padding' />
        </Grid>
        <Divider hidden />
        <Form onSubmit={this.handleSubmit}>
          <Grid stackable>
            <Grid.Column width={16} className='grid-padding'>
              <Segment>
                <BudgetHeader
                  showLoader={showLoader}
                  expenses_total={budget_totals.expenses_total}
                  incomes_total={budget_totals.incomes_total}
                  cash_flow={budget_totals.cash_flow}
                  expenses_total_projected={budget_totals_projected.expenses_total}
                  incomes_total_projected={budget_totals_projected.incomes_total}
                  cash_flow_projected={budget_totals_projected.cash_flow}
                  previous_month_incomes_total={budget_totals_previous.incomes_total}
                  previous_month_expenses_total={budget_totals_previous.expenses_total}
                  previous_month_cash_flow={budget_totals_previous.cash_flow}
                  three_month_avg_incomes_total={budget_totals_average.incomes_total}
                  three_month_avg_expenses_total={budget_totals_average.expenses_total}
                  three_month_avg_cash_flow={budget_totals_average.cash_flow}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column textAlign='right' width={16} className='grid-padding'>
              {
                this.state.success ?
                  <Message size='tiny' color='green' icon='checkmark' content='Data saved successfully!' />
                  :
                  null
              }
              {
                this.state.error ?
                  <Message size='tiny' color='red' icon='cancel' content={this.state.errorMessage} />
                  :
                  null
              }
              <Button
                icon='save'
                type='submit'
                primary
                content='Save'
                disabled={!formValid}
              />
            </Grid.Column>
          </Grid>

          <BudgetItem

            errorClass={this.errorClass}
            handleUserInput={this.handleUserInput}
            updateStateProp={this.handleChange}
            showLoader={showLoader}

            take_home_pay_valid={this.state.take_home_pay_valid}
            other_income_valid={this.state.other_income_valid}
            alimony_valid={this.state.alimony_valid}
            child_support_gain_valid={this.state.child_support_gain_valid}
            social_security_valid={this.state.social_security_valid}
            retirement_income_valid={this.state.retirement_income_valid}
            rent_valid={this.state.rent_valid}
            utilities_valid={this.state.utilities_valid}
            transportation_valid={this.state.transportation_valid}
            insurance_premiums_valid={this.state.insurance_premiums_valid}
            food_valid={this.state.food_valid}
            telephone_valid={this.state.telephone_valid}
            medical_bills_valid={this.state.medical_bills_valid}
            back_taxes_valid={this.state.back_taxes_valid}
            student_loans_valid={this.state.student_loans_valid}
            child_support_loss_valid={this.state.child_support_loss_valid}
            child_care_valid={this.state.child_care_valid}
            other_expenses_valid={this.state.other_expenses_valid}
            rent_2_valid={this.state.rent_2_valid}
            auto_other_valid={this.state.auto_other_valid}
            tv_valid={this.state.tv_valid}
            charity_valid={this.state.charity_valid}
            clothing_valid={this.state.clothing_valid}
            education_valid={this.state.education_valid}
            entertainment_valid={this.state.entertainment_valid}
            health_valid={this.state.health_valid}
            home_insurance_valid={this.state.home_insurance_valid}
            household_items_valid={this.state.household_items_valid}
            life_insurance_valid={this.state.life_insurance_valid}
            laundry_valid={this.state.laundry_valid}
            medical_care_valid={this.state.medical_care_valid}

            take_home_pay={this.state.take_home_pay}
            other_income={this.state.other_income}
            alimony={this.state.alimony}
            child_support_gain={this.state.child_support_gain}
            social_security={this.state.social_security}
            retirement_income={this.state.retirement_income}
            rent={this.state.rent}
            utilities={this.state.utilities}
            transportation={this.state.transportation}
            insurance_premiums={this.state.insurance_premiums}
            food={this.state.food}
            telephone={this.state.telephone}
            medical_bills={this.state.medical_bills}
            back_taxes={this.state.back_taxes}
            student_loans={this.state.student_loans}
            child_support_loss={this.state.child_support_loss}
            child_care={this.state.child_care}
            other_expenses={this.state.other_expenses}
            rent_2={this.state.rent_2}
            auto_other={this.state.auto_other}
            tv={this.state.tv}
            charity={this.state.charity}
            clothing={this.state.clothing}
            education={this.state.education}
            entertainment={this.state.entertainment}
            health={this.state.health}
            home_insurance={this.state.home_insurance}
            household_items={this.state.household_items}
            life_insurance={this.state.life_insurance}
            laundry={this.state.laundry}
            medical_care={this.state.medical_care}

            projected_take_home_pay={this.state.projected_take_home_pay}
            projected_other_income={this.state.projected_other_income}
            projected_alimony={this.state.projected_alimony}
            projected_child_support_gain={this.state.projected_child_support_gain}
            projected_social_security={this.state.projected_social_security}
            projected_retirement_income={this.state.projected_retirement_income}
            projected_rent={this.state.projected_rent}
            projected_utilities={this.state.projected_utilities}
            projected_transportation={this.state.projected_transportation}
            projected_insurance_premiums={this.state.projected_insurance_premiums}
            projected_food={this.state.projected_food}
            projected_telephone={this.state.projected_telephone}
            projected_medical_bills={this.state.projected_medical_bills}
            projected_back_taxes={this.state.projected_back_taxes}
            projected_student_loans={this.state.projected_student_loans}
            projected_child_support_loss={this.state.projected_child_support_loss}
            projected_child_care={this.state.projected_child_care}
            projected_other_expenses={this.state.projected_other_expenses}
            projected_rent_2={this.state.projected_rent_2}
            projected_auto_other={this.state.projected_auto_other}
            projected_tv={this.state.projected_tv}
            projected_charity={this.state.projected_charity}
            projected_clothing={this.state.projected_clothing}
            projected_education={this.state.projected_education}
            projected_entertainment={this.state.projected_entertainment}
            projected_health={this.state.projected_health}
            projected_home_insurance={this.state.projected_home_insurance}
            projected_household_items={this.state.projected_household_items}
            projected_life_insurance={this.state.projected_life_insurance}
            projected_laundry={this.state.projected_laundry}
            projected_medical_care={this.state.projected_medical_care}

            diff_take_home_pay={this.state.take_home_pay - this.state.projected_take_home_pay}
            diff_other_income={this.state.other_income - this.state.projected_other_income}
            diff_alimony={this.state.alimony - this.state.projected_alimony}
            diff_child_support_gain={this.state.child_support_gain - this.state.projected_child_support_gain}
            diff_social_security={this.state.social_security - this.state.projected_social_security}
            diff_retirement_income={this.state.retirement_income - this.state.projected_retirement_income}
            
            diff_rent={this.state.projected_rent - this.state.rent}
            diff_utilities={this.state.projected_utilities - this.state.utilities}
            diff_transportation={this.state.projected_transportation - this.state.transportation}
            diff_insurance_premiums={this.state.projected_insurance_premiums - this.state.insurance_premiums}
            diff_food={this.state.projected_food - this.state.food}
            diff_telephone={this.state.projected_telephone - this.state.telephone}
            diff_medical_bills={this.state.projected_medical_bills - this.state.medical_bills}
            diff_back_taxes={this.state.projected_back_taxes - this.state.back_taxes}
            diff_student_loans={this.state.projected_student_loans - this.state.student_loans}
            diff_child_support_loss={this.state.projected_child_support_loss - this.state.child_support_loss}
            diff_child_care={this.state.projected_child_care - this.state.child_care}
            diff_other_expenses={this.state.projected_other_expenses - this.state.other_expenses}
            diff_rent_2={this.state.projected_rent_2 - this.state.rent_2}
            diff_auto_other={this.state.projected_auto_other - this.state.auto_other}
            diff_tv={this.state.projected_tv - this.state.tv}
            diff_charity={this.state.projected_charity - this.state.charity}
            diff_clothing={this.state.projected_clothing - this.state.clothing}
            diff_education={this.state.projected_education - this.state.education}
            diff_entertainment={this.state.projected_entertainment - this.state.entertainment}
            diff_health={this.state.projected_health - this.state.health}
            diff_home_insurance={this.state.projected_home_insurance - this.state.home_insurance}
            diff_household_items={this.state.projected_household_items - this.state.household_items}
            diff_life_insurance={this.state.projected_life_insurance - this.state.life_insurance}
            diff_laundry={this.state.projected_laundry - this.state.laundry}
            diff_medical_care={this.state.projected_medical_care - this.state.medical_care}

            projected_readonly={this.state.projected_readonly}
            actual_readonly={this.state.actual_readonly}

          />

        </Form>
      </div>
    );

  }
}



// WEBPACK FOOTER //
// ./src/components/BudgetMonthly/index.js